<template>
  <div class='collection'>
    <div class="card-item" :style="{backgroundImage: 'url(' + cardItem.image_url + ')'}">
      <div class="card-item-top">
        <div class="card-item-title">
          <div class="card-item-name">{{cardItem.name}}</div>
          <div class="card-item-use" v-if="cardItem.num > 0">
            <div>可使用</div>
            <div class="num-use">{{cardItem.num}}</div>
            <div>次</div>
          </div>
        </div>
      </div>
      <div class="card-item-bottom">
        <div class="card-item-price">
          <span class="card-item-nowprice">¥{{(cardItem.price / 100).toFixed(2)}}</span>
          <span class="card-item-storeprice">门市价 ¥{{(cardItem.origin_price / 100).toFixed(2)}}</span>
        </div>
        <div class="card-item-button">
          立即购卡
        </div>
      </div>
    </div>
    <div class="card-bg-1"></div>
    <div class="card-bg-2"></div>
  </div>
</template>

<script type="span/ecmascript-6">
export default {
  name: 'Goods',
  props: {
    cardItem: {
      type: Object,
      default: () => { },
    },
  },
  data () {
    return {

    }
  },
  methods: {},
  mounted () { },
}
</script>

<style scoped lang="stylus">
.collection
  position relative
  .card-bg-1
    position absolute
    z-index 1
    bottom -5px
    width 100%
    height 172px
    background-image url('~@/assets/template/card-bg-1.png')
  .card-bg-2
    position absolute
    z-index 3
    bottom -5px
    width 100%
    height 44px
    background-image url('~@/assets/template/card-bg-2.png')
    background-repeat no-repeat
    background-size cover
  .card-item
    margin 0 auto
    margin-bottom 20px
    width 335px
    height 194px
    border-radius 10px
    background-size 100% 100%
    padding 20px
    box-sizing border-box
    display flex
    flex-direction column
    justify-content space-between
    position relative
    z-index 2
    .card-item-title, .card-item-bottom
      width 100%
      display flex
      justify-content space-between
      align-items flex-start
      line-height 1
    .card-item-name
      color #FFF6E1
      font-size 18px
      font-weight bold
      position absolute
      bottom 48px
      left 15px
    .card-item-use
      color #FFF6E1
      font-size 12px
      font-weight 500
      display flex
      align-items center
      position absolute
      bottom 16px
      right 27px
      .num-use
        background-color #FFF6E1
        color #000
        padding 1px 4px
        margin 0 2px
        line-height 1
    .card-item-price
      vertical-align bottom
      position absolute
      bottom 15px
      left 15px
    .card-item-nowprice
      color #FFF6E1
      font-family Gotham-Medium
      font-weight 600
      font-size 18px
    .card-item-storeprice
      color #FFF6E1
      font-weight 300
      font-size 12px
      margin-left 7px
    .card-item-button
      width 88px
      height 30px
      background-color #E8CE90
      text-align center
      line-height 30px
      border-radius 21px
      color #2D2F33
      font-size 12px
      font-weight bold
      position absolute
      top 130px
      right 15px
</style>



// WEBPACK FOOTER //
// src/components/content/modal/Card.vue